import { useState } from "react";

import { experience } from "../Data";

import { Row, Card, Badge } from "react-bootstrap";
import { FaExternalLinkAlt } from "react-icons/fa";

const Experience = () => {
    const [copied, setCopied] = useState("");

    const copyHandler = ({ firm, about, tech }) => {
        setCopied(firm);
        var s = "";
        if(about != null) {
            s = "\u2022 "+about.join("\n\u2022 ") + "\n\n";
        }
        s += "Technology used : " + tech.join(" , ");

        navigator.clipboard.writeText(s);
        setTimeout(() => setCopied(""), 750);
    };

    return (
        <>
            {experience.map((ex) => (
                <Row key={ex.firm} className="mb-3">
                    <Card>
                        <Card.Header className="text-center d-flex justify-content-between">
                            <a
                                href={ex.url}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <b>
                                    {ex.firm} <FaExternalLinkAlt />
                                </b>
                            </a>
                            <small>
                                <b>
                                    {ex.from}-{ex.to}
                                </b>
                            </small>
                        </Card.Header>
                        <Card.Body>
                            <div className="mt-1 mb-1">
                                <b>{ex.position}</b>
                            </div>
                            <Card.Subtitle className="text-muted">
                                <ul>
                                    {ex.about &&
                                        ex.about.map((line) => (
                                            <li key={line}>{line}</li>
                                        ))}
                                </ul>
                            </Card.Subtitle>
                        </Card.Body>
                        <Card.Footer>
                            <div className="d-flex justify-content-between">
                                <div>
                                    {ex.tech &&
                                        ex.tech.map((skill) => (
                                            <Badge key={skill} className="me-2">
                                                {skill}
                                            </Badge>
                                        ))}
                                </div>
                                <small>
                                    <b>
                                        {copied === ex.firm ? (
                                            "Copied"
                                        ) : (
                                            <i
                                                onClick={() =>
                                                    copyHandler({
                                                        firm: ex.firm,
                                                        about: ex.about,
                                                        tech: ex.tech,
                                                    })
                                                }
                                                style={{ cursor: "pointer" }}
                                            >
                                                <u>Copy</u>
                                            </i>
                                        )}
                                    </b>
                                </small>
                            </div>
                        </Card.Footer>
                    </Card>
                </Row>
            ))}
        </>
    );
};

export default Experience;
